module.exports = __webpack_public_path__ + "static/assets/2619a904d139450155a966be6c0f90c4.png";